import { HERO_COUNTER, WAITLIST_INTERESTS } from './site';

export const WAITLIST_PAGE = {
  hero: {
    tag: 'Launching soon',
    title: 'Join the waitlist',
    subtitle:
      'Whether you have capital to put to work or you are an entrepreneur seeking fair funding, be among the first to access Hello Gwiji when we launch.',
    chips: ['Early access', 'Capital partnerships', 'Everyday finance'],
  },
  form: {
    tag: 'Early access',
    title: 'Tell us about you',
    description:
      'We are building a transparent marketplace for capital partnerships and everyday finance. Share your details and we will notify you at launch.',
    nameLabel: 'Full name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email address',
    emailPlaceholder: 'you@example.com',
    interestLabel: 'What brings you to Hello Gwiji?',
    termsLabel: 'I agree to the',
    termsLink: '/terms-and-conditions',
    privacyLink: '/privacy-policy',
    submitLabel: 'Join the waitlist',
    submittingLabel: 'Joining...',
  },
  sidebar: {
    stat: HERO_COUNTER,
    points: [
      'Get notified when the platform opens in your region',
      'Create your profile before public launch',
      'Explore ventures, wallets, and everyday pay early',
    ],
    interests: WAITLIST_INTERESTS,
  },
  cta: {
    title: 'Questions before you join?',
    description: 'Talk to our team about partnerships, the platform, or early access.',
    button: 'Contact us',
    href: '/contact',
  },
} as const;
